"use strict";
// ------------------------------------
// Queries
// ------------------------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_BY_SKU = exports.REMOVE_SEARCH_TERM = exports.QUERY_SEARCH_HISTORY = exports.QUERY_SEARCH_SUGGESTIONS = exports.QUERY_CONTENT_BY_SEARCH = exports.contentResult = void 0;
exports.contentResult = `{
        id,
        title,
        subtitle,
        description,
        availableFormat,
        level,
        variantsCount,
        startDate,
        endDate,
        prices {
          currency
          amount
          channel {
            applicableUserRoles
            id
          }
          custom
        },
        externalUrl,
        contentSource,
        credits,
        contentfulType,
        contentType {
          name
          slug
        },
        slug,
        roles,
        matchedRoles,
        isLocked,
        image: featuredImage {
          altText
          caption
          credit
          title
          url
        }
        contentCategory {
          name
          slug
        }
        topics {
          id,
          name,
          slug
        }
        subtopics {
          id,
          name,
          slug
          topicId
          topicSlug
        }
        industries {
          id,
          name,
          slug
        }
        trends {
          id,
          name,
          slug
        }
        contentLanguages {
          id,
          name,
          slug
        }
        careerStages {
          id,
          name,
          slug
        }
        jobRoles {
          id,
          name,
          slug
        }
        locations {
          id,
          name,
          slug
        }
        countries {
          id,
          name,
          slug
          locationId
          locationSlug
        }
        states {
          id,
          name,
          slug
          locationId
          locationSlug
        }
        skills {
          id,
          name,
          slug
        }
        subskills {
          id,
          name,
          slug
          skillId
          skillSlug
        }
        firstTopic,
        timeToConsume,
        dateCreated,
        productType,
        originProductType,
        country,
        conferenceState,
        conferenceCity
        downloads{
          fileSize
        },
        parentProductInfo {
          sessions,
          upcomingDates
        },
        restrictionDetails {
          role
          membershipType
          learnMoreUrl
        },
        hasSectionAccessRestriction,
        topicalSubscriptions,
        showQuantity,
        bundleInfo {
          prices,
          bundleDiscountPercent,
          numberOfComponentProducts,
        }
        fundName,
        applyFreeTrial,
        published
      }`;
exports.QUERY_CONTENT_BY_SEARCH = `
  query getContentBySearch($searchQuery: String, $sortBy: String, $page: Int, $perPage: Int, $filters: Filters, $options: Options) {
    getContentBySearch(searchQuery: $searchQuery, sortBy: $sortBy, page: $page, perPage: $perPage, filters: $filters, options: $options) {
      results ${exports.contentResult},
      meta {
        total,
        perPage,
        page,
        aggs
      },
      suggestedSearchQuery
    }
  }
`;
exports.QUERY_SEARCH_SUGGESTIONS = `
query getSearchSuggestions($searchQuery: String!) {
  getSearchSuggestions(searchQuery: $searchQuery) {
    results {
      value,
      occurrence
    }, searchQuery
  }
}
`;
exports.QUERY_SEARCH_HISTORY = `
  query getSearchHistory($numberResults: Int!) {
    getSearchHistory(numberResults: $numberResults)
  }
`;
exports.REMOVE_SEARCH_TERM = `
  mutation removeSearchTerm($searchTerm: String!, $numberResults: Int!) {
    removeSearchTerm(searchTerm: $searchTerm, numberResults: $numberResults)
  }
`;
exports.GET_PRODUCT_BY_SKU = `
  query getESProductBySku($sku: String!) {
    getESProductBySku(sku: $sku)
  }
`;
//# sourceMappingURL=search-queries.js.map